import React, { useEffect, useState } from 'react';
import styles from './Home.module.scss';
import PageTitle from '../../../components/pageTitle/PageTitle';
import DashboardDirectorCard from '../../../components/dashboardDirectorCard/DashboardDirectorCard';
import LoadingOverlay from '../../../components/loadingOverlay/LoadingOverlay';
import axiosClient from '../../../api/axiosClient';
import { useToasts } from '../../../contexts/ToastContext';

const ProgramCoordinatorHome = () => {
  const { showToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    totalPrograms: 0,
    activePrograms: 0,
    totalStudents: 0,
    evaluationsPendingReview: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axiosClient.get('/dashboard/coordinator');
        setData(response.data || {});
      } catch (error) {
        showToast(error.message, 'error');
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [showToast]);

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <div className={styles.header}>
        <PageTitle label="Dashboard" />
      </div>
      <div className={styles.container}>
        <div className={styles.cardGrid}>
          <DashboardDirectorCard
            title="Total Programs"
            type="Blue"
            count={{ count: data.totalPrograms }}
          />
          <DashboardDirectorCard
            title="Active Programs"
            type="Blue Light"
            count={{ count: data.activePrograms }}
          />
          <DashboardDirectorCard
            title="Total Students"
            type="Blue"
            count={{ count: data.totalStudents }}
            showIcon
          />
          <DashboardDirectorCard
            title="Evaluations Pending Review"
            type="Blue Light"
            count={{ count: data.evaluationsPendingReview, showIcon: true }}
          />
        </div>
      </div>
    </>
  );
};

export default ProgramCoordinatorHome;
